import React from 'react';
import { FormattedMessage } from 'react-intl';

const NoData = () => {
  return (
    <h4 className="ui header">
      <FormattedMessage
        id="noData"
        description="Message to be displayed when there's no data to be found"
        default="No data."
      />
    </h4>
  );
};

export default NoData;



/** WEBPACK FOOTER **
 ** ./src/components/layout/noData/NoData.js
 **/